import { getCookies } from "./constant";

export function hasChildren(item) {
  const { items: children } = item;

  if (children === undefined) {
    return false;
  }

  if (children.constructor !== Array) {
    return false;
  }

  if (children?.length === 0) {
    return false;
  }

  return true;
}

export const CheckPermission = (permission, path = window.location.pathname) => {
  let callFunc = true;
  if (permission?.length) {
    callFunc = false;
    permission.forEach(function (item) {
      item = item.replace('*', '[a-zA-Z0-9]{24}');
      let regexp = new RegExp('(^' + item + '$)', 'gm');
      if (regexp.test(path)) callFunc = true;
    });
  }
  return callFunc;
}

export const checkContainsTargetString = (arr, targetString) => {
  if (getCookies("adminRole") === "admin") {
    return true
  } else {
    return arr.some(item => {
      if (typeof item === 'string') {
        const itemsArray = item.split(',');
        const mergedArray = arr.filter(entry => !itemsArray.includes(entry));
        const mergedString = mergedArray.join(','); // Combine elements into a string
        return mergedString.includes(targetString);
      }
      return false;
    });
  }

}
